// VesKuApp Azure Environment Configuration

export const environment = {
  production: false,
  appFlavor: 'veskuapp',

  api: {
    baseUrl: 'https://rajapinnat.ymparisto.fi/api/kansalaishavainnot/1.0',
    extension: true,
    apimSubscriptionKey: '2ef128ab7ecd4b378f42ff250ac078bc'
  },

  azure: {
    // VesKuApp-specific Azure AD B2C configuration
    clientId: 'VESKUAPP-CLIENT-ID', // TODO: Replace with actual client ID
    authority: 'https://sykecitobs.b2clogin.com/sykecitobs.onmicrosoft.com/B2C_1_SignUpSignIn',
    knownAuthorities: ['sykecitobs.b2clogin.com'],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,

    // Storage configuration
    storageUrl: 'https://sykecitobsstorage.blob.core.windows.net',
    containerName: 'veskuapp-uploads',
    sasToken: '', // Not needed - backend handles storage

    // API Scopes
    apiScopes: [],

    // Image upload API URL (same as api.baseUrl, backend appends /images)
    imageApiUrl: 'https://rajapinnat.ymparisto.fi/api/kansalaishavainnot/1.0'
  },

  useAzureStorage: false,
  useAzureAuth: false,

  // Disabled Firebase config (kept for reference/rollback)
  firebaseConfig: {
    apiKey: "AIzaSyBkbGvnvRmZjR9-GIf8490IclHwtpvx2Nw", // stored in ADO variable group, contents example: "weanc3l784a2n37rcla723nrcl87a2y3r8c-n7U"
    authDomain: "citobspwa-v2.firebaseapp.com", // stored in ADO variable group, contents example: "syke-veskuapp.firebaseapp.com"
    projectId: "citobspwa-v2", // stored in ADO variable group, contents example: "syke-veskuapp"
    storageBucket: "citobspwa-v2-test.firebasestorage.app", // stored in ADO variable group, contents example: "syke-veskuapp.firebasestorage.app"
    messagingSenderId: "921805502416", // stored in ADO variable group, contents example: "944994822519",
    appId: "1:921805502416:web:f186970b8fd7b488d06bd5" // stored in ADO variable group, contents example: "1:944994822519:web:7d636a749e2de2d121d972"
  }
};